export default __webpack_public_path__ + "/dist/images/image00001.602921d8868d0fb9452174da5d728cc6.jpg";